import script from "./ProjectOwnerInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectOwnerInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectOwnerInfo.vue?vue&type=style&index=0&id=19ddf055&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ddf055"]])

export default __exports__